/* eslint-disable global-require */

module.exports = {
	guides: require("./guides.json"),
	common: require("./common.json"),
	series: require("./series.json"),
	resources: require("./resources.json"),
};
